<template>
  <div class="expect-work-wrapper container">

    <div class="progressBar">
      <WProgressBar width="90%" />
    </div>

    <div class="choose-layout">
      <div class="choose-title2">
        <div class="choose-title-left2">定制专属求职方案</div>
        <div class="choose-title-right2" @click="doNotNeed()">不需要</div>
      </div>
       <div class="reminder2">选择求职方向以便为您推荐最合适的职位</div>
    </div>

    <div class="tag-wrapper tag-city">
      <div class="tag-title">意向城市</div>
      <div class="tag-content">
        <template v-for="(itemCity, indexCity) in hotIntentionCitys">
          <span class="tag-item" :class="{'active': itemCity.checked}" :key="itemCity.id" @click="selectHotCity(itemCity, indexCity)">{{itemCity.city_name}}</span>
        </template>
      </div>
    </div>

    <div class="tag-wrapper tag-job">
      <div class="tag-title">意向工作类型</div>
      <div class="tag-content">
        <template v-for="(itemJob, indexJob) in hotIntentionJobs">
          <span class="tag-item" :class="{'active': itemJob.checked}" :key="itemJob.profession_id" @click="selectHotJob(itemJob, indexJob)">{{itemJob.title}}</span>
        </template>
      </div>
    </div>

    <!-- 底部按钮 -->
    <div class="bottom-layout">
      <div class="circle-btn" @click="backward()">
        <img src="https://files.wondercv.com/intention/ic_left_arrow.png" class="ic-btn" alt="">
      </div>
      <div class="circle-btn" :class="{active: allowTheNext }" @click="forward()">
        <img :src="allowTheNext ? 'https://files.wondercv.com/intention/ic_white_right_arrow.png' : 'https://files.wondercv.com/intention/ic_left_arrow.png'" 
          class="ic-btn" :class="{right: !allowTheNext}" alt="">
      </div>
    </div>

    <!--  更多城市  -->
    <w-popup :state="cityState" @handleClose="handleCancelCity">
      <div slot="content" class="content content-city" @touchmove.prevent>
        <div class="top-btn">
          <div class="cancel-btn" @click="handleCancelCity">取消</div>
          <div class="confirm-btn" @click="handleConfirmCity">确定</div>
        </div>
        <div class="checkTags">
          <div class="tag" v-for="(item,index) in chooseCityList" :key="index">
            <span class="text">{{item.city_name}}</span>
            <span class="iconfont iconshanchu1" @click="handleDelCity(item,index)"></span>
          </div>
          <div class="already-placeholder" v-if="!chooseCityList.length">最多选择3项</div>
        </div>

        <div class="city-dialog flex">
          <div class="letter-wrapper" :class="chooseCityList.length?'active':''">
            <cube-scroll :data="letterAry" ref="letterScroll">
              <div class="letter">
                <div
                    class="letter-code"
                    :class="{'letter-active': currentLetterIndex === index}"
                    v-for="(letter, index) in letterAry"
                    :key="index"
                    @click="changeKey(index)"
                >{{letter}}
                </div>
              </div>
            </cube-scroll>
          </div>
          <div class="city" :class="chooseCityList.length?'active':''">
            <cube-scroll :data="[currentLetterIndex]" ref="cityScroll">
              <div class="city-list">
                <span
                    class="city-name flex-center"
                    :class="{'city-active': city.checked}"
                    @click="selectCity(city,index)"
                    v-for="(city,index) in cityAry[currentLetterIndex].part_cities"
                    :key="city.id"
                >{{city.city_name}}</span>
              </div>
            </cube-scroll>
          </div>
        </div>
      </div>
    </w-popup>

    <!-- 更多职位类型 -->
    <w-popup :state="jobState" @handleClose="handleCancelProfession">
       <!-- @touchmove.prevent -->
      <div slot="content" class="professionsTree">
        <div class="top-btn">
          <div class="cancel-btn" @click="handleCancelProfession">取消</div>
          <div class="confirm-btn" @click="handleConfirmProfession">确定</div>
        </div>
        <div class="checkTags">
          <div class="tag" v-for="(item,index) in professionsConfirmData" :key="index">
            <span class="text">{{item.title}}</span>
            <span class="iconfont iconshanchu1" @click="handleDeleteProfessions(item, index)"></span>
          </div>
          <div class="already-placeholder" v-if="!professionsConfirmData.length">最多选择3项</div>
        </div>
        

        <div class="tagContent">
          <div class="level1">
            <div class="item" :class="[professionsOptions.level1Index === index?'active':'']" v-for="(item,index) in professionsTree" :key="index" @click="professionsOptions.level1Index = index">
              {{item.label}}
            </div>
          </div>
          <template v-for="(item,index) in professionsTree">
            <div class="levels" v-if="professionsOptions.level1Index === index" :key="index">
              <div class="list">
                <div class="item" :class="[item.checked?'active':'']" @click="handleCheckProfessions({level1Index: index, listItem:item, type:'level1'})">{{item.title}}</div>
              </div>

              <template v-for="(sitem, sindex) in item.list">
                <div :key="sindex" v-if="sitem.title.substring(0,2) !== '其他'">
                  <div class="level2"><span>{{sitem.title}}</span></div>
                  <div class="list">
                    <!-- level2 -->
                    <!-- :class="[sitem.checked?'active':'',item.checked?'disabled':'']" -->
                    <div class="item"
                      :class="[sitem.checked?'active':'']"
                      @click="handleCheckProfessions({level1Index: index, level2Index: sindex, listItem:sitem, type:'level2'})"
                    >
                      <span>{{sitem.title}}</span>
                    </div>
                    <!-- level3 -->
                    <!-- :class="[ssitem.checked ?'active':'',item.checked || sitem.checked?'disabled':'']" -->
                    <div class="item"
                      :class="[ssitem.checked ?'active':'']"
                      v-for="(ssitem, ssindex) in sitem.list" :key="ssindex"
                      @click="handleCheckProfessions({level1Index: index, level2Index: sindex, level3Index: ssindex, listItem:ssitem, type:'level3'})"
                    >
                      <span>{{ssitem.title}}</span>
                    </div>

                  </div>
                </div>
              </template>
              <div class="feedback">
                <p>没有找到我的意向职位</p>
                <span @click="feedbackVisibile = true">立即反馈</span>
              </div>
            </div>
          </template>
        </div>
      </div>
    </w-popup>

    <feedback :feedbackVisibile = feedbackVisibile  @closeFeed="feedbackVisibile = false"/>
  </div>
</template>

<script>
import WProgressBar from '@/components/global/w-progress-bar'
import WPopup from '@/components/global/w-popup'
import HotIntentionCitys from '@/assets/json/hot_intention_citys.json'
import HotIntentionJobs from '@/assets/json/hot_intention_jobs.json'
import citiesData from '@/assets/json/global.json'
import staticApi from '@/api/api-list/static-api'
import intention from '@/api/api-list/intention'
import { componentsMixin } from '@/assets/js/mixin/components'
import { mapActions } from 'vuex'
import feedback from "./components/feedback.vue"

export default {
  mixins: [componentsMixin],
  data () {
    return {
      feedbackVisibile:false, //求职意向反馈弹窗
      hotIntentionCitys: JSON.parse(JSON.stringify(HotIntentionCitys)), // 求职意向热门城市
      hotIntentionJobs: JSON.parse(JSON.stringify(HotIntentionJobs)), // 求职意向热门职位
      chooseCityList: [], // 已选择城市集合
      cacheChooseCityList: [], // 缓存上一次已选择城市
      cityAry: [] , // 城市数组
      originCityAry: [], // 最初的城市数组，checked都为false
      letterAry: [], // 拼音数组
      currentLetterIndex: 0, // 选中的拼音下标
      professionsConfirmData: [], // 已选择职位集合
      cacheProfessionsConfirmData: [], // 缓存上一次选择职位
      professionsTree: [], //职位类型数据
      professionsOptions: {
        level1Index:0,
      },
      cityState: false, // 显示更多城市弹窗
      jobState: false // 显示更多职位弹窗
    }
  },
  components: {
    WProgressBar,
    WPopup,
    feedback
  },
  created () {
    // 初始化城市
    this.cityAry = citiesData.cities.cities
    this.letterAry = citiesData.cities.cities.map(city => city.group_name)
    this.originCityAry = JSON.parse(JSON.stringify(citiesData.cities.cities))
    // 获取职位数据
    this.getProfessionsTree()
  },
  computed: {
    // 选择来城市和职位，就可以执行下一步
    allowTheNext () {
      return this.chooseCityList.length > 0 && this.professionsConfirmData.length > 0
    }
  },
  methods: {
    ...mapActions('user', ['getUserIntention']),
    //不需要
    doNotNeed () {
      this.$router.push('/cvs')
    },
    // 后退
    backward () {
      this.$router.back()
    },
    // 前进
    async forward () {
      if (!this.allowTheNext) return
      let city_ids = this.chooseCityList.map(itemCity => itemCity.id)
      let profession_full_ids = this.professionsConfirmData.map(itemJob => itemJob.profession_id)
      let params = {
        city_ids,
        profession_full_ids
      }
      try {
        let res = await intention.updateIntentions(params)
        if (res.code === 1000) {
          this.getUserIntention()
          // this.$router.push('/cvs')
          this.$router.push('follow-company')
        }
      } catch (e) {
        console.log(e)
      }
    },


    // 关闭城市选择弹窗
    handleCancelCity() {
      // 取消时，读取上一次的选择
      this.chooseCityList = JSON.parse(JSON.stringify(this.cacheChooseCityList))
      this.cityState = false
    },
    // 确定城市选择
    handleConfirmCity() {
      this.cityState = false
      if (this.chooseCityList.length === 0) {
        this.chooseCityList.push({
          id: 0,
          city_name: "全国",
          checked: " active"
        })
      }
      this.makeEqualHotCity()
    },
    // 删除选中城市
    handleDelCity(item, index) {
      let cityAry = this.cityAry
      cityAry.map(j => {
        j.part_cities.map(i => {
          if (item.city_name == i.city_name) {
            i["checked"] = ""
          }
        })
      })
      this.cityAry = cityAry
      this.chooseCityList.splice(index, 1)
      this.$forceUpdate()
    },
    // 切换拼音
    changeKey(index) {
      this.currentLetterIndex = index
    },
    // 选择城市事件
    selectCity(city, index) {
      if (city.checked) {
        this.cityAry[this.currentLetterIndex].part_cities[index][
          "checked"
          ] = false
        this.chooseCityList.map((item, index) => {
          if (item.city_name == city.city_name) {
            this.chooseCityList.splice(index, 1)
          }
        })
      } else if (!city.checked) {
        if (this.chooseCityList.length == 3 && city.city_name != "全国") {
          this.showToast("最多选择三个")
          return
        } else if (
          this.chooseCityList.length == 3 &&
          city.city_name == "全国"
        ) {
          this.chooseCityList = []
          this.chooseCityList.push(city)
        }
        if (city.city_name == "全国") {
          this.cityAry.map(item => {
            item.part_cities.map(i => {
              if (i.city_name == "全国") {
                i.checked = true
              } else {
                i.checked = false
              }
            })
          })
          this.chooseCityList = []
          this.chooseCityList.push(city)
        } else {
          if (this.chooseCityList.length) {
            this.chooseCityList.map((item, index) => {
              if (item.city_name == "全国") {
                this.chooseCityList.splice(index, 1)
              }
            })
          }
          this.cityAry.map(item => {
            item.part_cities.map((i, index) => {
              if (i.city_name == "全国") {
                i.checked = false
              }
            })
          })

          this.chooseCityList.push(city)
        }
        this.cityAry.forEach((item, i) => {
          item.part_cities.forEach((city_item, j) => {
            if (city_item.city_name == city.city_name) {
              city_item.checked = true
            }
          })
        })
      }
      this.$forceUpdate()
    },
    // 选择热门城市
    selectHotCity (city, index) {
      // 点击更多，弹出更多弹窗，缓存上一次选择列表，取消时会用
      if (city.id === -1) {
        // 如果有选择热门城市，需要同步到城市列表
        if (this.chooseCityList.length > 0) {
          this.makeEqualCityList()
        }
        this.cityState = true
        // 每次弹出弹窗，都需要记录一下目前选择的城市（方便点取消的时候退回）
        this.cacheChooseCityList = JSON.parse(JSON.stringify(this.chooseCityList))
        return
      }
      // 已经选了三个城市，并且这次点击的是没有被选中的城市
      if (this.chooseCityList.length === 3 && !city.checked) return this.showToast("最多选择三个")
      if (city.checked) {
        // 取消选择
        this.chooseCityList.forEach((item, index) => {
          if (item.id === city.id) this.chooseCityList.splice(index, 1)
        })
        this.hotIntentionCitys[index].checked = false
      } else {
        // 选择
        city.checked = true
        this.chooseCityList.push(city)
        this.hotIntentionCitys[index].checked = true
      }
      this.makeEqualCityList()
      this.$forceUpdate()
    },
    // 选择的城市同步到热门城市
    makeEqualHotCity () {
      // 先把每个热门城市都初始化成未选中
      this.hotIntentionCitys.forEach((i, ind) => {
        this.hotIntentionCitys[ind].checked = false
      })
      this.chooseCityList.forEach((itemChoose) => {
        let hasSameCity = false
        this.hotIntentionCitys.forEach((itemHot, indexHot) => {
          // 选择中有热门城市，则给热门城市列表对应城市添加标识
          if (itemChoose.id === itemHot.id) {
            this.hotIntentionCitys[indexHot].checked = true
            hasSameCity = true
          }
        })
        // 没有相同城市，将作为新城市添加到热门城市列表中
        if (!hasSameCity) {
          itemChoose.checked = true
          this.hotIntentionCitys.push(itemChoose)
        }
      })
    },
    // 选择的城市同步到城市列表弹窗
    makeEqualCityList () {
      let cityAry = JSON.parse(JSON.stringify(this.originCityAry))
      this.chooseCityList.forEach(itemChoose => {
        cityAry.map(j => {
          j.part_cities.map(i => {
            if (itemChoose.city_name == i.city_name) {
              i["checked"] = true
            }
          })
        })
      })
      this.cityAry = cityAry
    },


    // 关闭职位选择弹窗
    handleCancelProfession () {
      // 取消时，读取上一次的选择
      this.professionsConfirmData = JSON.parse(JSON.stringify(this.cacheprofessionsConfirmData))
      this.jobState = false
    },
    // 确认职位选择
    handleConfirmProfession () {
      this.jobState = false
      this.makeEqualHotJob()
    },
    // 删除选中职位
    handleDeleteProfessions (job, index) {
      this.professionsConfirmData.splice(index, 1)
      this.professionsTree.forEach((item,index) => {
        if (job.profession_id === item.profession_id) {
          item.checked = false
        }
        // level2
        item.list.forEach((sitem,sindex) => {
          if (job.profession_id === sitem.profession_id) {
            sitem.checked = false
          }
          // level3
          sitem.list.forEach((ssitem, ssindex) => {
            if (job.profession_id === ssitem.profession_id) {
              ssitem.checked = false
            }
          })
        })
      })
    },
    //选择职业事件
    handleCheckProfessions ({level1Index, level2Index, level3Index, listItem, type,}) {
      if(type==='level1'){
        //查找当前是否已经选中
        let checkIndex = this.professionsConfirmData.findIndex(item=> item.profession_id === listItem.profession_id);
        //查找当前大分类中是否有已经选中的
        let hasCurrentLevel = this.professionsConfirmData.findIndex(item=> item.level1Index === level1Index);
        if(checkIndex>-1){
          //反选
          this.professionsConfirmData.splice(checkIndex,1);
          this.professionsTree[level1Index].checked = false;
        }else if(this.professionsConfirmData.length === 3 && hasCurrentLevel===-1){
          this.showToast("最多选择三个")
          return
        }else{
          this.professionsTree[level1Index].checked = true;
          // 向下清除选中状态(2/3级)
          this.professionsTree[level1Index].list.forEach((sitem,sindex)=>{
            let levelIndex = this.professionsConfirmData.findIndex(item=> item.profession_id === sitem.profession_id);
            if(levelIndex>-1){
              this.professionsConfirmData.splice(levelIndex,1);
            }
            sitem.checked = false;
            sitem.list.forEach(ssitem=>{
              let levelIndex = this.professionsConfirmData.findIndex(item=> item.profession_id === ssitem.profession_id);
              if(levelIndex>-1){
                this.professionsConfirmData.splice(levelIndex,1);
              }
              ssitem.checked = false;
            })
          })
          //添加
          this.professionsConfirmData.push({
            title: listItem.title,
            profession_id: listItem.profession_id,
            listItem,
            type,
            level1Index
          })
        }
      }else if(type === 'level2'){
        // 查找当前一级分类是否选中
        // if(this.professionsTree[level1Index].checked){
        //   return
        // }
        //查找当前是否已经选中
        let checkIndex = this.professionsConfirmData.findIndex(item=> item.profession_id === listItem.profession_id);
        //查找当前大分类/小模块中是否有已经选中的
        let hasCurrentLevel = this.professionsConfirmData.findIndex(item=> item.level1Index === level1Index && item.level2Index === level2Index);

        if(checkIndex>-1){
          //反选
          this.professionsConfirmData.splice(checkIndex,1);
          this.professionsTree[level1Index].list[level2Index].checked = false;
        }else if(this.professionsConfirmData.length === 3 && hasCurrentLevel===-1){
          this.showToast("最多选择三个")
          return
        }else{
          this.professionsTree[level1Index].list[level2Index].checked = true;
          // 向下清除选中状态（3级）
          this.professionsTree[level1Index].list[level2Index].list.forEach((sitem,sindex)=>{
            let levelIndex = this.professionsConfirmData.findIndex(item=> item.profession_id === sitem.profession_id);
            sitem.checked = false;
            if(levelIndex>-1){
              this.professionsConfirmData.splice(levelIndex,1);
            }
          })
          // 向上清除选中状态 (1级)
          let topItem = this.professionsTree[level1Index]
          let levelIndex = this.professionsConfirmData.findIndex(item=> item.profession_id === topItem.profession_id);
          topItem.checked = false;
          if(levelIndex>-1){
            this.professionsConfirmData.splice(levelIndex,1);
          }
          //添加
          this.professionsConfirmData.push({
            title: listItem.title,
            profession_id: listItem.profession_id,
            listItem,
            type,
            level1Index,
            level2Index,
          })
        }
      }else if(type === 'level3') {
        // if(this.professionsTree[level1Index].checked || this.professionsTree[level1Index].list[level2Index].checked){
        //   return
        // }
        // 向上清除选中状态 (1级)
        let topItem = this.professionsTree[level1Index]
        let levelIndex = this.professionsConfirmData.findIndex(item=> item.profession_id === topItem.profession_id);
        topItem.checked = false;
        if(levelIndex>-1){
          this.professionsConfirmData.splice(levelIndex,1);
        }
        // 向上清除选中状态 （2级）
        let level2Item = this.professionsTree[level1Index].list[level2Index]
        let targetLevel2Index = this.professionsConfirmData.findIndex(item=> item.profession_id === level2Item.profession_id);
        if(targetLevel2Index>-1){
          this.professionsConfirmData.splice(targetLevel2Index,1);
        }
        level2Item.checked = false;
        //查找当前是否已经选中
        let checkIndex = this.professionsConfirmData.findIndex(item=> item.profession_id === listItem.profession_id);
        if(checkIndex>-1){
          //反选
          this.professionsConfirmData.splice(checkIndex,1);
          this.professionsTree[level1Index].list[level2Index].list[level3Index].checked = false;
        }else if(this.professionsConfirmData.length === 3){
          this.showToast("最多选择三个")
          return
        }else{
          this.professionsTree[level1Index].list[level2Index].list[level3Index].checked = true;
         
          //添加
          this.professionsConfirmData.push({
            title: listItem.title,
            profession_id: listItem.profession_id,
            listItem,
            type,
            level1Index,
            level2Index,
            level3Index,
          })
        }
      }
    },
    // 选择热门职位
    selectHotJob (job, index) {
      if (job.profession_id === -1) {
        // 如果有选择热门职位，需要同步到职位列表
        if (this.professionsConfirmData.length > 0) {
          this.makeEqualJobList()
        }
        this.jobState = true
        // 每次弹出弹窗，都需要记录一下目前选择的职位（方便点取消的时候退回）
        this.cacheprofessionsConfirmData = JSON.parse(JSON.stringify(this.professionsConfirmData))
        return
      }
      // 已经选了三个职位，并且这次点击的是没有被选中的职位
      if (this.professionsConfirmData.length === 3 && !job.checked) return this.showToast("最多选择三个")
      if (job.checked) {
        // 取消选择
        this.professionsConfirmData.forEach((item, index) => {
          if (item.profession_id === job.profession_id) this.professionsConfirmData.splice(index, 1)
        })
        this.hotIntentionJobs[index].checked = false
      } else {
        // 选择
        job.checked = true
        this.professionsConfirmData.push(job)
        this.hotIntentionJobs[index].checked = true
      }
      this.makeEqualJobList()
      this.$forceUpdate()
    },
    // 获取树形结构的职位类型
    getProfessionsTree (){
      staticApi.getProfessionsTree().then(res => {
        if(res.code === 1000){
          // level1
          res.data.forEach((item,index) => {
            item.title = `全部${item.title}`
            item.checked = false
            // 去除 其他 开头的职位
            item.list = item.list.filter((filterItem, filterIndex) => !filterItem.title.startsWith('其他'))
            // level2
            item.list.forEach((sitem,sindex) => {
              sitem.title = `全部${sitem.title}`
              sitem.checked = false
              // level3
              sitem.list.forEach((ssitem, ssindex) => {
                ssitem.checked = false
              })
            })
          })
          this.professionsTree = res.data
        }
      })
    },
    // 选择的职位同步到热门职位
    makeEqualHotJob () {
      // 先把每个热门职位都初始化成未选中
      this.hotIntentionJobs.forEach((i, ind) => {
        this.hotIntentionJobs[ind].checked = false
      })

      this.professionsConfirmData.forEach((itemChoose) => {
        let hasSameJob = false
        this.hotIntentionJobs.forEach((itemHot, indexHot) => {
          // 选择中有热门职位，则给热门职位列表对应职位添加标识
          if (itemChoose.profession_id === itemHot.profession_id) {
            this.hotIntentionJobs[indexHot].checked = true
            hasSameJob = true
          }
        })
        // 没有相同职位，将作为新职位添加到热门职位列表中
        if (!hasSameJob) {
          itemChoose.checked = true
          this.hotIntentionJobs.push(itemChoose)
        }
      })
    },
    // 选择的职位同步到职位列表
    makeEqualJobList () {
      let jobAry = JSON.parse(JSON.stringify(this.professionsTree))
      let profession_ids = this.professionsConfirmData.map((item) => item.profession_id)

      jobAry.forEach((item,index)=>{
        //检测是否选中
        if(profession_ids.includes(item.profession_id)){
          item.checked = true
        }else{
          item.checked = false
        }
        
        // level2
        item.list.forEach((sitem,sindex)=>{
          //检测是否选中
          if(profession_ids.includes(sitem.profession_id)){
            sitem.checked = true
          }else{
            sitem.checked = false
          }
          
          // level3
          sitem.list.forEach((ssitem, ssindex)=>{
            //检测是否选中
            if(profession_ids.includes(ssitem.profession_id)){
              ssitem.checked = true
            }else{
              ssitem.checked = false
            }
          })

        })

      })

      this.professionsTree = jobAry

    }

  }
}
</script>

<style lang="scss" scoped>
  @import "./intentions/index.scss";
  .expect-work-wrapper {
    display: flex;
    flex-direction: column;
    height: 100vh;
    // position: relative;

    .progressBar {
      width: 100%;
      position: absolute;
      top: 16px;
      padding: 0 24px;
    }
    .choose-layout {
      -webkit-flex: 1 0 auto; 
      display: flex;
      flex-direction: column;
      padding: 70px 24px 0px 24px;
      margin: 0px 0px 48px 0px;
      .choose-title2 {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0px 0px 8px 0px;
        .choose-title-left2 {
          font-size: 24px;
          color: #404040;
          font-weight: 600;
        }
        .choose-title-right2 {
          font-size: 14px;
          font-weight: 400;
          color: #CFCFCF;
        }
        }
      .reminder2 {
        color: #9C9C9C;
        font-size: 14px;
        font-weight: 400;
        // margin-bottom: 48px;
      }
    }
    
    .tag-wrapper {

      .tag-title {
        margin-left: 24px;
        position: relative;
        font-size: 16px;
        font-weight: 500;
        color: #404040;
        margin-bottom: 16px;

        &::before {
          content: "";
          position: absolute;
          top: -10px;
          left: -11px;
          width: 21px;
          height: 21px;
          border-radius: 50%;
          z-index: -1;
        }
      }

      .tag-content {
        display: flex;
        flex-wrap: wrap;
        padding: 0 18px;

        .tag-item {
          font-size: 14px;
          line-height: 14px;
          font-weight: 400;
          color: #9C9C9C;
          padding: 8px 22px;
          border: 1px solid #ECECEC;
          border-radius: 15px;
          margin-left: 5px;
          margin-right: 5px;
          margin-bottom: 10px;
        }
      }

      &.tag-city {
        margin-bottom: 30px;
        .tag-title::before {
          background: linear-gradient(135deg, rgba(255, 102, 68, 0.3) 0%, #FFFFFF 80%);
        }
        .tag-item.active {
          color: #FF6644;
          border-color: #FF6644;
        }
      }

      &.tag-job {
        // margin-bottom: 76px;
        .tag-title::before {
          background: linear-gradient(135deg, #A3D0FF 0% , #FFFFFF 80%);
        }
        .tag-item.active {
          color: #4183FF;
          border-color: #4183FF;
        }
      }

    }

    // .forward-and-backward {
    //   width: 100%;
    //   position: absolute;
    //   bottom: 24px;
    //   display: flex;
    //   flex: 1;
    //   justify-content: space-between;
    //   padding: 0 24px;
    //   // margin-bottom: 20px;

    //   .handle-btn {
    //     display: flex;
    //     justify-content: center;
    //     align-items: center;
    //     width: 64px;
    //     height: 64px;
    //     background: #F9F9F9;
    //     border-radius: 50%;

    //     .iconfont {
    //       font-size: 36px;
    //       font-weight: 900;
    //       color: #cfcfcf;
    //     }

    //     &.forward-btn {
    //       &.active {
    //         background: linear-gradient(180deg, #FF9F79 0%, #FF6644 100%);

    //         .iconfont {
    //           color: #fff;
    //         }
    //       }
    //     }
    //     &.backward-btn {
    //       transform: rotate(180deg);
    //     }
    //     .img-check {
    //       width: 19px;
    //       height: 16px;
    //     }
    //   }
    // }

    .bottom-layout {
      position: absolute;
      bottom: 0;
      width: calc(100% - 48px) ;
      display: flex;
      align-items: flex-end;
      justify-content: space-between;
      margin: 24px;
      .circle-btn {
        display: flex;
        width: 64px;
        height: 64px;
        background: #F9F9F9;
        border: 1px solid #F4F4F4;
        border-radius: 32px;
        justify-content: center;
        align-items: center;
        .ic-btn {
          width: 12px;
          height: 20px;
          &.right{
            transform: rotate(180deg);
          }
        }
        &.active {
          background: linear-gradient(180deg, #FF9F79 0%, #FF6644 100%);
          box-shadow: 0px 6px 24px -8px #FF6644;
          border: none;
        }
      }
    }

    .professionsTree {

      .checkTags .tag {
        color: #4183FF;
        border-color: #4183FF;
      }

      .tagContent .levels .list .item.active {
        color: #4183FF;
        border-color: #4183FF;
      }
    }

  }
</style>
